
import { ComponentCreator, createComponentCreator, styleInject } from 'packages/css-component-modules';

const _css = `.MobileContainer_96e5841640fa1397{display:block}.DesktopContainer_4b3ce13f7458c8b0{display:none}.DesktopTitleStyles_ae67a1c07a491d49{margin-left:32px;margin-bottom:16px}.MainContainer_e3a61c021350ac4e{width:100%}.MainContent_cba02e6ed59becf7{background-color:#fff}.DisclosureStyle_d47729e88283e678{padding:16px 0}@media (min-width:600px),(orientation:landscape){.DesktopContainer_4b3ce13f7458c8b0{display:block}.MobileContainer_96e5841640fa1397{display:none}.MainContainer_e3a61c021350ac4e{width:100%;max-width:664px}}`;
styleInject(_css)

/** MobileContainer Props */
export type MobileContainerCCM = {
  /** MobileContainer Component Custom Properties */
  // No custom properties found

  /** MobileContainer Modifier Flags */
  // No modifiers classes found
};
/** Base MobileContainer component */
export const MobileContainer: ComponentCreator<MobileContainerCCM> = createComponentCreator({
  "name": "MobileContainer",
  "base": "MobileContainer_96e5841640fa1397",
  "prop": {},
  "mod": {}
});


/** DesktopContainer Props */
export type DesktopContainerCCM = {
  /** DesktopContainer Component Custom Properties */
  // No custom properties found

  /** DesktopContainer Modifier Flags */
  // No modifiers classes found
};
/** Base DesktopContainer component */
export const DesktopContainer: ComponentCreator<DesktopContainerCCM> = createComponentCreator({
  "name": "DesktopContainer",
  "base": "DesktopContainer_4b3ce13f7458c8b0",
  "prop": {},
  "mod": {}
});


/** DesktopTitleStyles Props */
export type DesktopTitleStylesCCM = {
  /** DesktopTitleStyles Component Custom Properties */
  // No custom properties found

  /** DesktopTitleStyles Modifier Flags */
  // No modifiers classes found
};
/** Base DesktopTitleStyles component */
export const DesktopTitleStyles: ComponentCreator<DesktopTitleStylesCCM> = createComponentCreator({
  "name": "DesktopTitleStyles",
  "base": "DesktopTitleStyles_ae67a1c07a491d49",
  "prop": {},
  "mod": {}
});


/** MainContainer Props */
export type MainContainerCCM = {
  /** MainContainer Component Custom Properties */
  // No custom properties found

  /** MainContainer Modifier Flags */
  // No modifiers classes found
};
/** Base MainContainer component */
export const MainContainer: ComponentCreator<MainContainerCCM> = createComponentCreator({
  "name": "MainContainer",
  "base": "MainContainer_e3a61c021350ac4e",
  "prop": {},
  "mod": {}
});


/** MainContent Props */
export type MainContentCCM = {
  /** MainContent Component Custom Properties */
  // No custom properties found

  /** MainContent Modifier Flags */
  // No modifiers classes found
};
/** Base MainContent component */
export const MainContent: ComponentCreator<MainContentCCM> = createComponentCreator({
  "name": "MainContent",
  "base": "MainContent_cba02e6ed59becf7",
  "prop": {},
  "mod": {}
});


/** DisclosureStyle Props */
export type DisclosureStyleCCM = {
  /** DisclosureStyle Component Custom Properties */
  // No custom properties found

  /** DisclosureStyle Modifier Flags */
  // No modifiers classes found
};
/** Base DisclosureStyle component */
export const DisclosureStyle: ComponentCreator<DisclosureStyleCCM> = createComponentCreator({
  "name": "DisclosureStyle",
  "base": "DisclosureStyle_d47729e88283e678",
  "prop": {},
  "mod": {}
});

